import { render, staticRenderFns } from "./ImsProfitLossList.vue?vue&type=template&id=2f1a282a&"
import script from "./ImsProfitLossList.vue?vue&type=script&lang=js&"
export * from "./ImsProfitLossList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports